<div>
  <div class="sidebar-overlay" [class.is-visible]="isSidebarOpenState()" (click)="closeSidebar()"></div>

  <div class="left_col scroll-view sticky v_sidebar" [class.is-open]="isSidebarOpenState()">
    <div class="clearfix"></div>

    <br>

    <div id="sidebar-menu" class="main_menu_side hidden-print main_menu">
      <div class="menu_section active">
        <ul class="nav side-menu">
          <li>
            <a routerLink="/dashboard" (click)="closeSidebar()"><i class="fa fa-dashboard" aria-hidden="true"></i><span class="menu-text">Dashboard</span></a>
          </li>
          <li>
            <a routerLink="/users" (click)="closeSidebar()"><i class="fa fa-user" aria-hidden="true"></i><span class="menu-text">Users</span></a>
          </li>
          <li>
            <a routerLink="/subscription-plans" (click)="closeSidebar()"><i class="fa fa-building-o" aria-hidden="true"></i><span class="menu-text">Subscription Plans</span></a>
          </li>
          <li>
            <a routerLink="/manage-content" (click)="closeSidebar()"><i class="fa fa-cog" aria-hidden="true"></i><span class="menu-text">Manage Content</span></a>
          </li>
          <li>
            <a routerLink="/revenue" (click)="closeSidebar()"><i class="fa fa-usd" aria-hidden="true"></i><span class="menu-text">Revenue</span></a>
          </li>
          <li>
            <a routerLink="/subscription-report" (click)="closeSidebar()"><i class="fa fa-file-text" aria-hidden="true"></i><span class="menu-text">Subscription Report</span></a>
          </li>
          <li>
            <a routerLink="/verify-realtimeImage" (click)="closeSidebar()"><i class="fa fa-user" aria-hidden="true"></i><span class="menu-text">Verify Medical Reciept</span></a>
          </li>
          <li>
            <a routerLink="/approve-consultants" (click)="closeSidebar()"><i class="fa fa-user-md" aria-hidden="true"></i><span class="menu-text">Approve Consultants</span></a>
          </li>
          <li>
            <a routerLink="/notification-management" (click)="closeSidebar()"><i class="fa fa-bell" aria-hidden="true"></i><span class="menu-text">Notification Management</span></a>
          </li>
          <li>
            <a routerLink="/more-analytics" (click)="closeSidebar()"><i class="fa fa-bar-chart" aria-hidden="true"></i><span class="menu-text">More Analytics</span></a>
          </li>
          <li>
            <a routerLink="/affiliates" (click)="closeSidebar()"><i class="fa fa-users" aria-hidden="true"></i><span class="menu-text">Affiliates</span></a>
          </li>
          <li>
            <a routerLink="/manage-reports" (click)="closeSidebar()"><i class="fa fa-flag" aria-hidden="true"></i><span class="menu-text">Reports & Appeals</span></a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>